import Vue from 'vue';
export default {
    install(){
        Vue.prototype.$renderEllipsisHeader = function (h, {column}) {
            return h('div', {class: 'text-overflow-ellipsis vertical-align-middle display-inline-block p-0'}, column.label)
        }
    }
}
